import { Seo, Eyebrow } from "@/components/site/primitives";
import { Reveal, Stagger, Item } from "@/components/site/motion";
import { PageHero, Section } from "@/components/site/pageparts";
import { TEAM, COMPANY } from "@/data/site";

const RECOGNITION = [
  { n: "NASSCOM deeptech", file: "/brand/backers/nasscom-deeptech.png", d: "India's apex technology-industry body — deeptech cohort." },
  { n: "ELEVATE Nxt · Govt. of Karnataka", file: "/brand/backers/elevate-nxt.png", d: "A deep-tech grant-in-aid initiative supporting frontier AI research built in India." },
  { n: "Startup Karnataka", file: "/brand/backers/startup-karnataka.png", d: "Karnataka's flagship programme supporting startups." },
  { n: "Innovate Karnataka", file: "/brand/backers/innovate-karnataka.png", d: "State innovation initiative backing deep-tech ventures." },
  { n: "DPIIT", file: "/brand/backers/dpiit.png", d: "Recognised by the Department for Promotion of Industry and Internal Trade." },
  { n: "MSME · Govt. of India", file: "/brand/backers/msme.png", d: "Registered under the Ministry of Micro, Small & Medium Enterprises." },
];

export default function About() {
  return (
    <div data-testid="about-page">
      <Seo title="About" description="DataFrontier is a research lab building memory as infrastructure, from Bengaluru for the world." />
      <PageHero
        eyebrow="Company · About"
        title="A research lab with one obsession: memory."
        lead="Today's AI is brilliant and amnesiac. We believe the memory an AI holds about a person or an institution should belong to that person or institution — not to a model vendor. So we build the missing layer: memory as infrastructure, sovereign and verifiable."
      />

      <Section>
        <Reveal>
          <Eyebrow>Team</Eyebrow>
          <h2 className="mt-5 font-serif text-3xl tracking-tighter text-bone md:text-5xl">Who's building it.</h2>
        </Reveal>
        <Stagger className="mt-16 grid gap-12 md:grid-cols-3">
          {TEAM.map((m) => (
            <Item key={m.name}>
              <div className="aspect-[4/5] w-full overflow-hidden border border-white/10 bg-ink-800">
                <img src={m.image} alt={m.name} className="h-full w-full object-cover grayscale transition-all duration-700 hover:grayscale-0" loading="lazy" />
              </div>
              <h3 className="mt-6 font-serif text-2xl text-bone">{m.name}</h3>
              <div className="mt-1 font-mono text-xs uppercase tracking-[0.14em] text-saffron">{m.role}</div>
              <p className="mt-4 text-[15px] leading-relaxed text-mist">{m.bio}</p>
            </Item>
          ))}
        </Stagger>
      </Section>

      <Section className="border-t border-white/10">
        <Reveal>
          <Eyebrow>Recognized & supported by</Eyebrow>
        </Reveal>
        <Stagger className="mt-10 grid gap-px border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-3">
          {RECOGNITION.map((r) => (
            <Item key={r.n} className="bg-ink p-7">
              <div className="flex h-14 w-40 items-center justify-center border border-white/10 bg-bone/95 px-4">
                <img src={r.file} alt={r.n} className="max-h-8 w-auto object-contain" loading="lazy" />
              </div>
              <div className="mt-5 font-serif text-lg text-bone">{r.n}</div>
              <p className="mt-2 text-sm leading-relaxed text-mist">{r.d}</p>
            </Item>
          ))}
        </Stagger>
      </Section>

      <Section className="border-t border-white/10">
        <Reveal className="max-w-2xl">
          <Eyebrow>Registered entity</Eyebrow>
          <div className="mt-6 space-y-2 font-mono text-sm text-mist">
            <div className="text-bone">{COMPANY.legalName}</div>
            <div>{COMPANY.address}</div>
            <div>CIN {COMPANY.cin}</div>
            <div>
              <a href={`mailto:${COMPANY.emails.hello}`} className="hover:text-bone">{COMPANY.emails.hello}</a>
            </div>
          </div>
        </Reveal>
      </Section>
    </div>
  );
}
